import React from 'react';
import ChooseUs from '../ChooseUs/ChooseUs';
import Footer from '../Footer/Footer';
import WordPress from '../PackagePrice/WordPress';
import Portfolioes from '../Portfolioes/Portfolioes';
import Services from '../Services/Services';
import Skill from '../Skills/Skill';
import OwlSlider from '../Slider/OwlSlider';
import TeamsMember from '../Team/TeamsMember/TeamsMember';
import Testimonial from '../Testimonial/Testimonial';
import './Home.css';

const Home = () => {
    return (
            <div id="home">
                <div className="mainBg">
                </div>
                <Services/>
                <Portfolioes/>
                <Skill/>
                <ChooseUs/>
                <OwlSlider/>
                <Testimonial/>
                <TeamsMember/>
                <WordPress/>
                <div className="footer">
                <br />
                <br />
                    <Footer/>
                </div>
            </div>
    );
};

export default Home;